import React, { ReactElement, useState } from 'react';
import CardActions from '@mui/material/CardActions';
import TextFieldEditor from '../../field/editors/textfieldeditor';
import QuestionBox from "../box";
import QuestionValue from "../value";
import { QuestionEditorProps, TextQuestionSpec, Value } from '../../../types/types';
import QuestionEditorButton from "../questioneditorbutton";
import QuestionLabel from '../label';

function TextQuestionEditor(props: QuestionEditorProps<TextQuestionSpec>) : ReactElement {
  const [value, setValue] = useState<Value>(props.answer?.value as string);

  return (
    <QuestionBox>
      <QuestionLabel spec={props.spec} />
      <QuestionValue>
        <TextFieldEditor value={value as string || ''} setValue={setValue} />
      </QuestionValue>
      <CardActions>
        <QuestionEditorButton response={value} setResponse={setValue} defaultValue={props.answer?.value} buttonsSettings={props.buttonsSettings} />
      </CardActions>
    </QuestionBox>
  );
}
export default TextQuestionEditor;
